import React, { useReducer, useEffect } from "react";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import { loadData } from "./service";
import Html from "./html";

const AllCustomers = () => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        loadData(state.page_number, state.serach_text, state.sort_key, state.sort_direction, dispatch);
    }, [state.page_number, state.serach_text, state.sort_key, state.sort_direction]);

    return(
        <Context.Provider value={{state, dispatch}}>
            <Html/>
        </Context.Provider>
    );
}

export default AllCustomers;